export const GET_STATS_PENDING = 'GET_STATS_PENDING'
export const GET_STATS_SUCCESSFUL = 'GET_STATS_SUCCESSFUL'
export const GET_STATS_ERROR = 'GET_STATS_ERROR'
